module.exports = __webpack_public_path__ + "static/img/1_6_1.b0df7aeb.jpg";